export const featuredPortfolio = [
    {
      id: 1,
      title: "React App",
      img:
        "assets/reactJS.jpg",
    },
    {
      id: 2,
      title: "UI Design",
      img:
        "assets/userInterface.png",
    },
    {
      id: 3,
      title: "React Native",
      img:
        "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
    },
    {
      id: 4,
      title: "Wordpress website",
      img:
        "assets/wordpress.jpg",
    },
    {
      id: 5,
      title: "E-commerce design",
      img:
        "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
    },
    {
      id: 6,
      title: "Node JS",
      img:
        "assets/nodeJS.jpg",
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Wordpress Sites",
      img: "assets/wordpress.jpg",
    },
    {
      id: 2,
      title: "React App",
      img: "assets/reactJS.jpg",
    },
    {
      id: 3,
      title: "E-commerce Design",
      img: "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
    },
    {
      id: 4,
      title: "Web Design",
      img: "https://cdn.dribbble.com/users/387658/screenshots/15458608/media/e92ec1dd33dd1170ae3dc9c5272f2693.jpg?compress=1&resize=1200x900",
    },
    {
      id: 5,
      title: "Crypto and JWT",
      img: "assets/jwt.jpg",
    },
  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Mobile Social Media App",
      img:
        "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
    },
    {
      id: 2,
      title: "Mobile Shopping App",
      img:
        "assets/mobileShopping.png",
    },
    {
      id: 3,
      title: "Mobile SDK",
      img:
        "assets/mobileSDK.png",
    },
    {
      id: 4,
      title: "React Native",
      img:
        "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
    },
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "UI Design",
      img:
        "assets/userInterface.png",
    },
    {
      id: 2,
      title: "Graphic Editing",
      img:
        "assets/adobe.jpg",
    },
    {
      id: 3,
      title: "Logo Designing",
      img:
        "assets/adobeAi.png",
    },
    {
      id: 4,
      title: "Video Editing",
      img:
        "assets/videoEditing.png",
    },
    {
      id: 5,
      title: "3D Design",
      img:
        "assets/blender.png",
    },
  ];
  
  export const contentPortfolio = [
    {
      id: 1,
      title: "Assignment Help",
      img:
        "assets/assignmentHelp.svg",
    },
    {
      id: 2,
      title: "Blogging website",
      img:
        "assets/blogging.jpg",
    },
    {
      id: 3,
      title: "Data entry",
      img:
        "assets/dataEntry.png",
    },
    {
      id: 4,
      title: "Digital marketing and SEO",
      img:
        "assets/digitalMarketing.png",
    },
    {
      id: 5,
      title: "Software testing",
      img:
        "assets/softwareTesting.jpg",
    },
  ];
  